import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { Logo } from "@/components/site/Logo";

const PASSWORD = "OWOLOVO2026";
const STORAGE_KEY = "owo_unlocked";

export const PasswordGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(false);
  const [ready, setReady] = useState(false);
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === "1") setUnlocked(true);
    setReady(true);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (value === PASSWORD) {
      localStorage.setItem(STORAGE_KEY, "1");
      setUnlocked(true);
    } else {
      setError(true);
    }
  };

  if (!ready) return null;
  if (unlocked) return children;

  return (
    <div
      data-testid="password-gate"
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-paper px-5"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md border border-hair bg-white p-8 md:p-12"
      >
        <Logo height={26} />
        <div className="mt-10 flex h-12 w-12 items-center justify-center bg-owo-pink">
          <Lock size={22} className="text-ink" />
        </div>
        <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-tight text-ink">
          Strona zabezpieczona
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-graphite">
          Ten materiał B2B jest chroniony hasłem. Wpisz hasło dostępu, aby zobaczyć kampanię.
        </p>

        <form onSubmit={submit} className="mt-8">
          <input
            type="password"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setError(false);
            }}
            data-testid="password-input"
            placeholder="Hasło dostępu"
            autoFocus
            className="w-full border border-ink bg-transparent px-4 py-4 text-base text-ink outline-none placeholder:text-graphite/60 focus:border-owo-pink"
          />
          {error && (
            <p data-testid="password-error" className="mt-3 text-sm font-medium text-owo-pink">
              Nieprawidłowe hasło. Spróbuj ponownie.
            </p>
          )}
          <button
            type="submit"
            data-testid="password-submit"
            className="mt-6 w-full bg-owo-pink px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] text-ink transition-colors hover:bg-[#ef7ba6]"
          >
            Odblokuj
          </button>
        </form>
      </motion.div>
    </div>
  );
};
